var InlineButtonVariants;
(function (InlineButtonVariants) {
    InlineButtonVariants["Default"] = "default";
    InlineButtonVariants["Select"] = "select";
})(InlineButtonVariants || (InlineButtonVariants = {}));
var InlineButtonElementTypes;
(function (InlineButtonElementTypes) {
    InlineButtonElementTypes["Button"] = "button";
    InlineButtonElementTypes["Link"] = "a";
    InlineButtonElementTypes["Upload"] = "label";
})(InlineButtonElementTypes || (InlineButtonElementTypes = {}));
var InlineButtonAlignments;
(function (InlineButtonAlignments) {
    InlineButtonAlignments["Start"] = "start";
    InlineButtonAlignments["Center"] = "center";
    InlineButtonAlignments["End"] = "end";
})(InlineButtonAlignments || (InlineButtonAlignments = {}));
var InlineButtonBadgeTypes;
(function (InlineButtonBadgeTypes) {
    InlineButtonBadgeTypes["Premium"] = "premium";
    InlineButtonBadgeTypes["Verified"] = "verified";
    InlineButtonBadgeTypes["Star"] = "star";
    InlineButtonBadgeTypes["Ambassador"] = "ambassador";
    InlineButtonBadgeTypes["MasterContributor"] = "masterContributor";
    InlineButtonBadgeTypes["MasterStoryteller"] = "masterStoryteller";
    InlineButtonBadgeTypes["Dot"] = "dot";
    InlineButtonBadgeTypes["DotPremium"] = "dotPremium";
    InlineButtonBadgeTypes["New"] = "new";
    InlineButtonBadgeTypes["NewPremium"] = "newPremium";
    InlineButtonBadgeTypes["Try"] = "try";
    InlineButtonBadgeTypes["TryPremium"] = "tryPremium";
    InlineButtonBadgeTypes["Beta"] = "beta";
    InlineButtonBadgeTypes["AiRectangle"] = "aiRectangle";
    InlineButtonBadgeTypes["AiCircle"] = "aiCircle";
    InlineButtonBadgeTypes["Plus"] = "plus";
    InlineButtonBadgeTypes["Pro"] = "pro";
    InlineButtonBadgeTypes["Like"] = "like";
    InlineButtonBadgeTypes["Follow"] = "follow";
    InlineButtonBadgeTypes["Comment"] = "comment";
    InlineButtonBadgeTypes["Replay"] = "replay";
    InlineButtonBadgeTypes["NewPost"] = "newPost";
    InlineButtonBadgeTypes["Save"] = "save";
    InlineButtonBadgeTypes["Tag"] = "tag";
    InlineButtonBadgeTypes["Mention"] = "mention";
    InlineButtonBadgeTypes["Remix"] = "remix";
    InlineButtonBadgeTypes["Sticker"] = "sticker";
    InlineButtonBadgeTypes["Challenges"] = "challenges";
    InlineButtonBadgeTypes["Admin"] = "admin";
    InlineButtonBadgeTypes["FileShare"] = "fileShare";
    InlineButtonBadgeTypes["FileJoined"] = "fileJoined";
    InlineButtonBadgeTypes["PlusCrown"] = "plusCrown";
    InlineButtonBadgeTypes["ProCrown"] = "proCrown";
    InlineButtonBadgeTypes["Gold"] = "gold";
    InlineButtonBadgeTypes["PlusReverse"] = "plusReverse";
    InlineButtonBadgeTypes["ProReverse"] = "proReverse";
    InlineButtonBadgeTypes["GoldReverse"] = "goldReverse";
    InlineButtonBadgeTypes["Free"] = "free";
    InlineButtonBadgeTypes["AiAvatar"] = "aiAvatar";
    InlineButtonBadgeTypes["ProTrial"] = "proTrial";
    InlineButtonBadgeTypes["PlusTrial"] = "plusTrial";
    InlineButtonBadgeTypes["CrownTrial"] = "crownTrial";
})(InlineButtonBadgeTypes || (InlineButtonBadgeTypes = {}));

export { InlineButtonAlignments, InlineButtonBadgeTypes, InlineButtonElementTypes, InlineButtonVariants };
